export function deviceIsMobile(): boolean {
    // Use a regular expression to test the userAgent string for common mobile device identifiers.
    return /Android|webOS|iPhone|IEMobile|Opera Mini/i.test(navigator.userAgent)
        ? true // If any of the identifiers are found, return 'Mobile'.
        : false; // Otherwise, return 'Desktop'.

}


export function zoomOutMobile(newValue?: string): string {
    const viewport = document.querySelector('meta[name="viewport"]') as any;
    if (!viewport) { return ''; }

    const oldValue = viewport.content;

    console.log('ratio', window.visualViewport.scale);
    console.log('viewport.content', viewport.content);

    viewport.content = 'initial-scale=1, width=device-width, maximum-scale=1, user-scalable=no';

    setTimeout(() => {
        console.log('ratio-after', window.visualViewport.scale);
        console.log('viewport.content-after', viewport.content);
    }, 500);


    return oldValue;


}